import { useSelector, useDispatch } from 'react-redux';
import {
  projectCohortPickerSelectors,
  projectCohortPickerActions,
} from '../redux/modules/projectCohortPicker';
import { Cohort } from '../common/types/Cohorts';

export const useActiveProjectCohort = (): [Cohort, Function] => {
  const dispatch = useDispatch();
  const activeProjectCohort = useSelector(
    projectCohortPickerSelectors.selectActiveProjectCohort,
  );
  const setActiveProjectCohort = async (newActiveCohort: Cohort) =>
    await dispatch(
      projectCohortPickerActions.setActiveProjectCohort(newActiveCohort.id),
    );

  return [activeProjectCohort, setActiveProjectCohort];
};

export default useActiveProjectCohort;
